<template>
    <div>
        <modal ref="modal" @close="goBack()" :content-class="'bg-purple-900'">
            <router-view v-slot="{ Component }">
                <transition name="slide-right" mode="out-in">
                    <keep-alive>
                        <component :is="Component" :key="$route.fullPath"></component>
                    </keep-alive>
                </transition>
            </router-view>
        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            id: String
        },

        mounted() {
            this.$refs.modal.open();
        },

        methods: {
            goBack() {
                this.$router.go(-1);
            }
        }

    }
</script>